import { post } from "@selector/shared";
import type { components } from "@selector/shared/openapi";

export type RegionExportRequest = components["schemas"]["RegionExportRequest"];
export type TableExportRequest = components["schemas"]["TableExportRequest"];

export async function exportRanges(payload: RegionExportRequest, fileKey: string) {
  const { response } = await post("/exportRegion", undefined, { fileKey }, payload);
  return response;
}

export async function exportTable(payload: TableExportRequest, fileKey: string) {
  const { response } = await post("/exportTable", undefined, { fileKey }, payload);
  return response;
}
